import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { PagingResponse } from '@models/paging-response.model';
import { CodingField } from 'src/app/models/field/coding-field.model';

@Injectable({
	providedIn: 'root'
})
export class CodingFieldsService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	getFields(respectLayout?: boolean): Observable<PagingResponse<CodingField>> {
		let url = `${this.appConfigService.getConfig().webApi}/api2/codingfields`;

		if (respectLayout) url += '?respectLayout=true';

		return this.http.get<PagingResponse<CodingField>>(url).pipe(catchError(this.errorHandler.handleError<PagingResponse<CodingField>>(`get coding fields`)));
	}

	getTextFields(): Observable<PagingResponse<CodingField>> {
		return this.http.get<PagingResponse<CodingField>>(`${this.appConfigService.getConfig().webApi}/api2/codingfields?$filter=Type eq 1`).pipe(
			catchError(this.errorHandler.handleError<PagingResponse<CodingField>>(`get text coding fields`)));
	}

	getTextFieldsByFieldId(fieldId: string, top: number, skip: number): Observable<PagingResponse<any>> {
		return this.http.get<PagingResponse<any>>(`${this.appConfigService.getConfig().webApi}/api2/codingFields/textField/${fieldId}?$count=true&$top=${top}&$skip=${skip}`).pipe(
			catchError(this.errorHandler.handleError<PagingResponse<any>>(`get text coding fields by field Id`)));
	}

	addCustomField(field: CodingField): Observable<any> {
		return this.http.post<CodingField>(`${this.appConfigService.getConfig().webApi}/api2/codingfields`, field)
			.pipe(catchError(this.errorHandler.handleError<CodingField>('saving coding field')));
	}
}
